import React, {useState, useContext} from 'react';
import {makeStyles} from "@material-ui/core/styles";
import useWindowDimensions from "../../useWindowDimensions";
import SideNavBarMUI from '../../components/manager/SideNavBarMUI';
import ReactApexChart from 'react-apexcharts'
import DashboardCard from "../../components/manager/DashboardCard";
import MasterContext from "../../context/MasterContext";
import IndicatorsContext from "../../context/MasterContext/IndicatorsContext";
import AdvisersControlTable from "../../components/manager/AdvisersControlTable";
import EncodeSansBold from '../../assets/fonts/Encode_Sans/EncodeSans-Bold.ttf';
import {
    Card,
    CardContent,
} from '@material-ui/core';
import {Modal} from "rsuite";

const useStyles = makeStyles(theme => ({
    modalChartCard: {
        width: "400px",
        height: "304px",
        margin: "8px 8px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
    },
    modalTitle: {
        fontFamily: "EncodeSansBold",
        fontSize: "20px",
        color: "#bb0d66",
        textAlign: "center",
        marginBottom: "16px"
    },
    parentColumn: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center"
    },
    cardStyle: {
        boxShadow: "2px 2px 2px 2px rgba(0, 0, 0, 0.2)",
    },
    divHeader: {
        display: "flex",
        flexDirection: "row",
        width: "100%",
        position: "absolute",
        marginBottom: "30px"
    },
    divButtons: {
        display: "flex",
        flexDirection: "row",
        margin: "20px"
    },
    divRow: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-evenly",
        marginBottom: "32px",
        marginTop: "32px"
    },
    generalIndicatorsColumn: {
        display: "flex",
        flexDirection: "column",
        alignSelf: "self-end",
        justifySelf: "center",
        justifyContent: "center",
        alignItems: "center",
        marginLeft: "8px"
    },
    divCardColumn: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-evenly",
    },
    buttonNewAffinity: {
        borderRadius: "30px",
        color: "#fff",
        fontSize: "20px",
        background: "#BB0D66",
        padding: "10px 30px 10px 30px",
        margin: "10px 0px 10px 0px",
        textdecoration: "none",
        border: "solid #BB0D66 0px",
        '&:hover': {
            backgroundColor: "#000000",
        },
    },
    parentBodyRow: {
        display: "flex",
        flexDirection: "row",
        width: "100%",
        height: "100%",
        position: "absolute",
        justifyContent: "center"
    },
    chartCard: {
        backgroundColor: "#fff",
        borderRadius: "5px",
        padding: "20px",
        width: "auto",
        height: "auto",
        boxShadow: "5px 10px 18px #888888",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center"
    },
    modalColumn: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "space-evenly"
    },
}))

const generalBarChartOptions = (title) => {
    return (
        {
            chart: {
                height: 360,
                width: 400,
                type: 'bar',
                toolbar: {
                    show: false
                },
            },
            colors: ['#BB0D66'],
            plotOptions: {
                bar: {
                    borderRadius: 10,
                    dataLabels: {
                        position: 'top', // top, center, bottom
                    },
                }
            },
            dataLabels: {
                enabled: true,
                formatter: function (val) {
                    return val;
                },
                offsetY: -20,
                style: {
                    fontSize: '12px',
                    colors: ["#304758"]
                }
            },

            xaxis: {
                categories: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
                position: 'top',
                axisBorder: {
                    show: false
                },
                axisTicks: {
                    show: false
                },
                crosshairs: {
                    fill: {
                        type: 'gradient',
                        gradient: {
                            colorFrom: '#D8E3F0',
                            colorTo: '#BED1E6',
                            stops: [0, 100],
                            opacityFrom: 0.4,
                            opacityTo: 0.5,
                        }
                    }
                },
                tooltip: {
                    enabled: true,
                }
            },
            yaxis: {
                axisBorder: {
                    show: false
                },
                axisTicks: {
                    show: false,
                },
                labels: {
                    show: false,
                    formatter: function (val) {
                        return val;
                    }
                }

            },
            title: {
                text: title,
                floating: true,
                offsetY: 330,
                align: 'center',
                style: {
                    color: '#444'
                }
            }
        }
    )
}

const generalPieChartOptions = (labels, title) => {
    return (
        {
            colors: ['#BB0D66', '#3D4977', '#AAA1C8', '#D5C6E0', '#F5E6E8'],
            chart: {
                width: 400,
                height: 320,
                type: 'pie',
            },
            labels: labels,
            title: {
                text: title,
                // align: 'center',
                // style: {
                //     color: '#444'
                // }
            },
        }

    )
}


const DashboardManager = () => {

    const classes = useStyles();
    const {width, height} = useWindowDimensions();
    const {open} = useContext(MasterContext);
    const [modalOpen, setModalOpen] = useState(false);
    const [modalCharts, setModalCharts] = useState(<div/>);
    const [modalTitle, setModalTitle] = useState("");
    const {
        advisersData,
        affinitiesQuantity,
        monthlyEmissionsQuantity,
        monthlyAverageQuota,
        monthlyPremium,
        totalAverageQuota,
        totalEmissionsQuantity,
        totalEmissionsByAffinity,
        totalQuotationsByAffinity,
        totalQuotationsQuantity,
    } = useContext(IndicatorsContext);

    const totalAverageQuotaFixed = "$ " + totalAverageQuota.toFixed(2)
    const monthlyPremiumFixed = "$ " + monthlyPremium.toFixed(2)
    const conversionRate = ((totalEmissionsQuantity / totalQuotationsQuantity) * 100).toFixed(2) + "%";

    const monthlyEmissionsQuantityChartSeries = [{
        name: 'Emisiones Mensuales',
        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, monthlyEmissionsQuantity, 0, 0]
    }];
    const monthlyAverageQuotaChartSeries = [{
        name: 'Cuota promedio mensual',
        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, monthlyAverageQuota, 0, 0]
    }];

    const handleModalOpen = (whichModal) => {
        switch (whichModal) {
            case 0:
                setModalTitle("Información adicional sobre emisiones")
                setModalCharts(
                    <div className={classes.divRow}>
                        <Card className={classes.modalChartCard}>
                            <CardContent style={{height: "100%", padding: "4px"}}>
                                <ReactApexChart
                                    options={generalPieChartOptions(Object.keys(totalEmissionsByAffinity), 'Emisiones por afinidad',)}
                                    series={Object.values(totalEmissionsByAffinity)} type="pie"/>
                            </CardContent></Card>
                        <Card className={classes.modalChartCard}>
                            <CardContent style={{height: "100%", padding: "4px"}}>
                                <ReactApexChart options={generalBarChartOptions("Emisiones mensuales")}
                                                series={monthlyEmissionsQuantityChartSeries} type="bar"/>
                            </CardContent></Card>

                    </div>);
                break;
            case 1:
                setModalTitle("Información adicional sobre cotizaciones")
                setModalCharts(
                    <div className={classes.divRow}>
                        <Card className={classes.modalChartCard}>
                            <CardContent style={{height: "100%", padding: "4px"}}>
                                <ReactApexChart
                                    options={generalPieChartOptions(Object.keys(totalQuotationsByAffinity), 'Cotizaciones por afinidad',)}
                                    series={Object.values(totalQuotationsByAffinity)} type="pie"/>
                            </CardContent></Card>

                    </div>
                );
                break;
            case 2:
                setModalTitle("Información adicional sobre cuota promedio")
                setModalCharts(
                    <Card className={classes.modalChartCard}>
                    <CardContent style={{height: "100%", padding: "4px"}}>

                        <ReactApexChart options={generalBarChartOptions("Cuota promedio mensual")}
                                        series={monthlyAverageQuotaChartSeries} type="bar"/>
                    </CardContent></Card>
                )
                break;
        }
        setModalOpen(!modalOpen)
    }

    return (
        <React.Fragment>

            <div className={classes.divHeader}>
                <SideNavBarMUI role={"Administrador"}/>
            </div>
            <div className={classes.parentBodyRow}
                 style={{
                     left: open ? "240px" : "60px",
                     transitionProperty: "left",
                     transitionDuration: "1s",
                     width: open ? `${width - 260}px` : `${width - 80}px`
                 }}
            >

                <div className={classes.generalIndicatorsColumn} style={{height: `${height - 64}px`}}>
                    <DashboardCard title={"AFINIDADES"} value={affinitiesQuantity}
                                   backColor={"#fff"} trend={1}/>
                    <div onClick={() => handleModalOpen(2)}><DashboardCard title={"CUOTA PROMEDIO"}
                                                                           value={totalAverageQuotaFixed}
                                                                           backColor={"#fff"} trend={1}/></div>
                    <DashboardCard title={"PRIMA ANUALIZADA"} value={monthlyPremiumFixed}
                                   backColor={"#fff"} trend={1}/>


                </div>

                <div className={classes.generalIndicatorsColumn} style={{height: `${height - 64}px`}}>
                    <div onClick={() => handleModalOpen(1)}><DashboardCard title={"COTIZACIONES"}
                                                                           value={totalQuotationsQuantity}
                                                                           cursor={"default"} backColor={"#fff"}
                                                                           trend={1}/></div>
                    <div onClick={() => handleModalOpen(0)}><DashboardCard title={"EMISIONES"}
                                                                           value={totalEmissionsQuantity}
                                                                           backColor={"#fff"} trend={1}/></div>

                    <DashboardCard title={"TASA DE CONVERSIÓN"} value={conversionRate} cursor={"default"}
                                   backColor={"#fff"} trend={1}/>
                </div>

                <div className={classes.generalIndicatorsColumn}
                     style={{height: `${height - 64}px`, marginLeft: "48px"}}>
                    <Card
                        className={classes.cardStyle}
                        style={{width: "auto", height: "auto", backgroundColor: "#fff", margin: "8px 8px"}}
                    >
                        <CardContent style={{height: "100%", padding: "8px"}}>
                            <AdvisersControlTable advisersData={advisersData}/></CardContent></Card>
                </div>
            </div>


            <Modal size={"lg"} backdrop={true} show={modalOpen} onHide={() => setModalOpen(!modalOpen)}
                   style={{top: '24px', left: open ? `88px` : `8px`, transitionProperty: "left",
                       transitionDuration: "1s",}}>
                <Modal.Header>

                </Modal.Header>
                <Modal.Body>

                    <div className={classes.modalColumn}>
                        <p className={classes.modalTitle}>{modalTitle}</p>
                        {modalCharts}
                    </div>
                </Modal.Body>
            </Modal>
        </React.Fragment>
    )
        ;
};

export default DashboardManager;
